import React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useValidateApdexConfig } from '../../hooks/useValidateApdexConfig';

export function ApdexConfigWarning({ objetivoId }) {
  const { t } = useTranslation();
  const {
    isLoading: isLoadingValidateApdex,
    data: validateApdexData,
    isSuccess: isSuccessValidateApdex,
  } = useValidateApdexConfig({ objetivoId });

  if (
    isLoadingValidateApdex ||
    !isSuccessValidateApdex ||
    validateApdexData === 'OK'
  ) {
    return null;
  }

  return (
    <Box marginBottom={2}>
      <Alert severity="warning">
        <AlertTitle>
          {t ? t('apdex.validate.error.title') : 'Error de validación'}
        </AlertTitle>
        {t('apdex.validate.error.' + validateApdexData) ||
          t('apdex.validate.error.default') ||
          ''}
      </Alert>
    </Box>
  );
}
